import styled from 'styled-components'
import theme from 'styles/theme'
import { Title32 } from 'components/Typography'
import { rem } from 'polished'

export const EventDetailWrapper = styled.div`
  color: ${theme.colors.sagedark};
`

export const EventDetailHeader = styled(Title32)`
  margin-bottom: 40px;

  &::after {
    background-color: ${theme.colors.sagelight};
    content: '';
    display: block;
    height: 1px;
    margin: 40px auto 0;
    width: 40px;
  }

  ${theme.mediaQueries.large} {
    margin-bottom: 60px;

    &::after {
      margin-top: 60px;
      width: 80px;
    }
  }
`

export const EventDetailCopy = styled.div`
  margin-bottom: 60px;
  text-align: center;
  font-size: ${rem(16)} !important;
`

export const EventDetailMeta = styled.div`
  margin-bottom: 30px;
`
